<template>
  <el-container>
    <el-main>
      <span style="font-size: 14px;color: #606266">
          评价管理
      </span>
      
      <el-select v-if="orgType == 1" placeholder="" size="small" placeholder="机构" v-model="searchData.orgCode" @change="changeOrg" style="margin-left: 15px;">
        <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
      </el-select>
      <div style="height: 60px; width: 70%; background-color: rgb(251, 248, 248); margin-top: 5px;">
        <el-select placeholder="" size="small" clearable placeholder="商品" v-model="searchData.commodityId" @change="changeCommodity" style="margin-left: 15px; width: 30%">
          <el-option v-for="c in commodityData" :label="c.courseName" :value="c.commodityId"></el-option>
        </el-select>
        <div style="float: right; margin-right: 15px;" @change="changeStatus">
          <el-radio v-model="searchData.isReply" label="" >全部评价（{{allTotal}}）</el-radio>
          <el-radio v-model="searchData.isReply" label="1">已回复</el-radio>
          <el-radio v-model="searchData.isReply" label="0">未回复</el-radio>
        </div>
      </div>
      <div>
        <div v-if="commentData.length == 0" style="text-align: center; width: 70% ;line-height: 60px;color: #909399; font-size: 14px; border-bottom: #d7d6d6 1px solid">
          暂无数据
        </div>
        <div v-for="comment in commentData">
          <div class="question-content" style="width: 70%;font-size:14px; border-bottom: 1px solid #ccc; margin-bottom: 5px">
            <div class="question-faceimg" style=" width: 200px">
              <img :src="comment.headerUrl == ''? defaultImg:comment.headerUrl" alt=""  width="55" height="55">
              <!--<img v-if="comment.headerUrl == '' " src="../../assets/img/touxiang.png" alt=""  width="55" height="55">-->
              <!--<img v-if="comment.headerUrl != '' " :src="comment.headerUrl" alt=""  width="55" height="55">-->
              <span style="margin-left: 3px;">{{comment.commentName}}</span>
            </div>
            <div style="width: 85%;" >
              <div style="margin-top: 5px; ">
                <el-rate disabled  v-model="comment.xingCount" style="float: left; flex: 1; text-align: left;"></el-rate>
                <div style="flex: 0; text-align: right;">
                  <el-button @click="updateCommentSort(comment)" type="text"   >{{comment.commentSort | isTop}}</el-button>
                  <el-button @click="showReply(comment)" type="text" :disabled="comment.isReply==1" >{{comment.isReply | replyFilter}}</el-button>
                  <el-button @click="deleteComment(comment)"  type="text" >删除</el-button>
                </div>
              </div>
              <p style="min-height: 35px; line-height: 35px;">{{comment.commentMsg}}</p>
              <p style="height: 35px; line-height: 35px;">评价来自《{{comment.courseName}}》 {{comment.creatTime | dateFilter}}</p>
              <div v-if="comment.isReply" style="width: 100%; border-bottom: 1px solid #ccc"></div>
              <div v-if="comment.isReply" v-for="reply in comment.mallReplyInfoList" class="question-content" style="width: 100%;font-size:14px; margin-bottom: 5px">
                <div >
                  <p style="height: 35px; line-height: 35px; ">客服回复:</p>
                  <div  >
                    <p style="min-height: 35px; line-height: 35px;">{{reply.replyMsg}}</p>
                    <p style="height: 35px; line-height: 35px;">{{reply.creatTime | dateFilter}}</p>
                  </div>
                </div>
                <div style="flex: 1; text-align: right; align-content: right;">
                  <el-button @click="deleteReply(reply)"  type="text" >删除</el-button>
                </div>
              </div>
            </div>
          </div>
          
          <div style="width: 70%;" id="">
            <el-form ref="['replyForm'+comment.commentId]" v-if="showReplyForm[comment.commentId]" :model="replyData" label-width="80px" label-position="top">
              <el-row >
                <el-input
                    type="textarea"
                    :rows="5"
                    style=" padding: 0 20px"
                    placeholder="请输入内容"
                    v-model="replyData.msg">
                </el-input>
              </el-row>
              <el-row style="float: right">
                <el-button @click="reply(comment)" size="small" type="primary" >确定</el-button>
                <el-button @click="showReplyForm[comment.commentId] = false;replyData.msg=''"  size="small" type="info" style="margin-right: 20px" >取消</el-button>
              </el-row>
            </el-form>
          </div>
        </div>
        <div style="width: 70%">
          <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="searchData.size"
              @size-change="handleSizeChange"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              style="margin-top: 5px; float: right; margin-right: 10px">
          </el-pagination>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>

  import {dateFormat} from "@/api/utils"
  
  export default {
    name: '',
    data() {
      return {
        defaultImg: require('../../assets/img/tx2.png'),
        org: [],
        showReplyForm: [],
        commodityData: [],
        commentData: [],
        orgCode: '',
        orgType:'',
        total: 0,
        allTotal: 0,
        textarea: '',
        pageSize: 10,
        currentPage: 1,
        searchData: {
          size: 20,
          page: 1,
          commodityId: '',
          orgCode: '',
          isReply: ''
        },
        replyData: {
          msg: '',
        },
      };
    },
    methods: {
      handleSizeChange(){},
      handleCurrentChange(val) {
        this.searchComment(val)
      },
      showReply(row) {
        this.replyData.msg = '';
        this.showReplyForm = [];
        this.$set(this.showReplyForm,row.commentId,1);
      },
      
      updateCommentSort(row) {
        console.log(row)
        let commentSort;
        if(row.commentSort == 1) {
          commentSort = 0;
        } else {
          commentSort = 1;
        }
        let param = {
          commentId: row.commentId,
          commentSort: commentSort
        };
        this.https.fetchPost('/mallCommentInfo/updateCommentSort', param, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.$message({
              type: 'success',
              message: "操作成功"
            });
            row.commentSort = commentSort;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      reply(row) {
        //  /mallReplyInfo/saveMallReplyInfo
        if(this.replyData.msg.length == 0) {
          this.$message({
            type: 'info',
            message: "回复内容不能为空！"
          });
          return
        }
        if(this.replyData.msg.length > 100) {
          this.$message({
            type: 'info',
            message: "回复内容不能超过100个字！"
          });
          return
        }
        let param = {
          commentId: row.commentId,
          replyMsg: this.replyData.msg
        };
        this.https.fetchPost('/mallReplyInfo/saveMallReplyInfo', param, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.$message({
              type: 'success',
              message: "操作成功"
            });
            this.replyData.msg='';
            this.showReplyForm[row.commentId] = false;
            this.searchComment();
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      deleteReply(row) {
        this.$confirm('此操作将删除此回复, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = {
            replyId: row.replyId
          };
          this.https.fetchPost('/mallReplyInfo/deleteMallReplyInfo', param, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == 200) {
              this.$message({
                type: 'success',
                message: "操作成功"
              });
              this.searchComment();
            } else {
              this.$message({
                type: 'info',
                message: msg
              });
            }

          }).catch(err => {
                console.log(err);
                this.$message.error('网络错误');
              }
          );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteComment(row) {
        this.$confirm('此操作将删除此评价, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = {
            commentId: row.commentId
          };
          this.https.fetchPost('/mallCommentInfo/deleteCommentInfo', param, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == 200) {
              this.$message({
                type: 'success',
                message: "操作成功"
              });
              this.searchComment();
            } else {
              this.$message({
                type: 'info',
                message: msg
              });
            }

          }).catch(err => {
                console.log(err);
                this.$message.error('网络错误');
              }
          );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
        
      },
      changeStatus() {
        this.searchComment();
      },
      changeOrg() {
        this.searchData.commodityId = '';
        this.selectCommodity();
        this.searchComment();
      },
      
      selectOrg() {
        this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.org = data.data.data;
            if(this.org.length > 0) {
              this.searchData.orgCode = this.org[0].orgCode;
            }
            this.selectCommodity();
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      selectCommodity() {
        let params = {
          orgCode: this.searchData.orgCode,
        };
        this.https.fetchPost('/mallCommentInfo/selectCommodityListbByCommentAndOrgCode',params, 'json' ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            if(data.data.data) {
              this.commodityData = data.data.data;
            } else {
              this.commodityData = [];
            }
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              console.log(err);
            }
        );
      },
      changeCommodity(val) {
        this.searchComment();
      },
      searchComment(val) {
        if(val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        let params = this.searchData;
        this.https.fetchPost('/mallCommentInfo/selectCommentListbByCommodityIdAndOrgCode',params , 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            if(data.data.data.list != null) {
              this.commentData = data.data.data.list;
              this.total = data.data.data.total;
            }
            this.selectTotal();
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }
        }).catch(err=>{
              this.$message.error('网络异常！');
            }
        );
      },
      selectTotal() {
        let params = {
          commodityId: this.searchData.commodityId,
          orgCode: this.searchData.orgCode
        };
        this.https.fetchPost('/mallCommentInfo/selectCountByCommodityIdAndOrgCode',params , 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.allTotal = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }
        }).catch(err=>{
              this.$message.error('网络异常！');
            }
        );
        // this.allTotal = 10;
      },
    },
    filters: {
      dateFilter (value) {
        if (!value) return ''
        return dateFormat(value);
      },
      isTop(value) {
        if(value == 0) {
          return "置顶";
        } else {
          return "取消置顶"
        }
      },
      replyFilter(val) {
        if(val == 0) {
          return '回复';
        } else {
          return "已回复"
        }
      }
    },
    created: function() {
      this.orgCode = this.$store.state.eblcuOrg;
      this.orgType = this.$store.state.orgType;
      this.searchData.orgCode = this.$store.state.orgCode;
      this.selectOrg();
      this.searchComment();
    }
  };
</script>

<style scoped>
  .question-content{
    display: flex;
    justify-content: flex-start;
  }
  .question-faceimg{
    display: flex;
    display: -webkit-flex;
    justify-content: left;
    padding: 10px;
  
  }
</style>
